import { useContext } from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { ContractEntry } from '@octopus/api';
import { isBRCltContract } from '@octopus/contract-types';
import { formatCNPJ, formatMonthBR } from '@octopus/formatters';

import { AppContext } from '../../context';
import { formatTimeSinceAdmission } from '../utils';

import { DrawerCard } from './Card';

export const Aggrements = ({ contract }: { contract: ContractEntry }) => {
  const { appContext } = useContext(AppContext);
  const cnpj = isBRCltContract(contract)
    ? contract.br?.regime?.cnpjSindCategProf
    : undefined;
  const admissionDate = isBRCltContract(contract)
    ? contract.br?.regime?.dtAdm
    : undefined;
  const dataBase = isBRCltContract(contract)
    ? contract.br?.regime?.dtBase
    : undefined;
  const sindicatos = appContext?.company?.sindicatos || [];
  const matched = sindicatos.find((s) => s.summary.associationCnpj === cnpj);

  return (
    <DrawerCard>
      <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography variant="h4">Detalhes</Typography>
      </Box>
      <Divider />
      <Box pl={1.25} display="flex" flexDirection="column" gap={0.5}>
        <Box display="flex" gap={0.5}>
          <Typography variant="subtitle2" color="text.secondary">
            Tempo de casa:
          </Typography>
          <Typography variant="subtitle2" color="text.primary">
            {formatTimeSinceAdmission(admissionDate, 'long')}
          </Typography>
        </Box>
        {matched?.name && (
          <Box display="flex" gap={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              Sindicato:
            </Typography>
            <Typography variant="subtitle2" color="text.primary">
              {matched?.name}
            </Typography>
          </Box>
        )}
        {cnpj && (
          <Box display="flex" gap={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              CNPJ Sindicato:
            </Typography>
            <Typography variant="subtitle2" color="text.primary">
              {formatCNPJ(cnpj)}
            </Typography>
          </Box>
        )}
        {dataBase && (
          <Box display="flex" gap={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              Data base:
            </Typography>
            <Typography variant="subtitle2" color="text.primary">
              {formatMonthBR(dataBase)}
            </Typography>
          </Box>
        )}
      </Box>
    </DrawerCard>
  );
};
